import store from '../store/store';
import { getFallbackValueIfNull } from 'owa-options-core';
import { getUserConfiguration } from 'owa-session-store';
import { updateUserConfigurationAndService } from 'owa-userconfiguration/lib/utils/updateUserConfigurationAndService';

export default async function saveMessagePreviewOption(): Promise<void> {
    await onMessagePreviewToggle(store().showPreviewTextInListView);
}

export async function onMessagePreviewToggle(isEnabled: boolean | null): Promise<void> {
    const newValue = getFallbackValueIfNull(
        isEnabled,
        getUserConfiguration().UserOptions?.ShowPreviewTextInListView
    );

    await updateUserConfigurationAndService({
        UserOptions: {
            ShowPreviewTextInListView: newValue,
        },
    });
}
